import { useEffect } from "react";
import { styled } from "@mui/material/styles";
import { Text } from "../UI";
import close from "../asserts/img/red-close.svg";
import error from "../asserts/img/error.svg";
import { useTranslation } from "react-i18next";

const Container = styled("div")(() => ({
  width: "fit-content",
  minHeight: 54,
  display: "flex",
  flexDirection: "row",
  backgroundColor: "#FBEBEE",
  color: "red",
  position: "absolute",
  bottom: 15,
  left: 0,
  right: 0,
  margin: "0 auto",
  marginBottom: 30,
  gap: 10,
  padding: "14px 20px 14px 20px",
  borderRadius: 12,
  alignItems: "center",
  zIndex: 99999,
}));

const Line = styled("div")(({ isRtl }) => ({
  "&::after": {
    content: "''",
    position: "absolute",
    height: "30px",
    width: "1px",
    borderRight: `1px dotted #D92D20`,
    top: 0,
    bottom: 0,
    margin: "auto",
    left: isRtl ? 60 : "unset",
    right: !isRtl ? 60 : "unset",
    zIndex: 99999,
  },
}));

const ErrorNotification = ({ text, onClose, withAction = false }) => {
  const { i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";

  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 100000000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Container>
      <img alt="error message" src={error} />
      <div style={{ maxWidth: 525, marginInlineEnd: 12 }}>
        <Text color={"#D92D20"}> {text} </Text>
      </div>
      <Line isRtl={isRtl} />
      <img
        onClick={() => {
          onClose();
        }}
        style={{ marginInlineStart: withAction ? "unset" : "auto" }}
        alt="close error"
        src={close}
      />
    </Container>
  );
};

export default ErrorNotification;
